import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { currentRouteSet } from "../../actions/actions";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import {
  pathSpliter,
  dateTimeFormat,
  currentDateTime,
  getDateTimeFromISODT,
} from "../../lib/functions";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import axios from "axios";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import ReceiptIcon from "@material-ui/icons/Receipt";
import DateFnsUtils from "@date-io/date-fns"; // choose your libs
import { API_URL } from "../../config";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import SearchIcon from "@material-ui/icons/Search";
import PrintIcon from "@material-ui/icons/Print";
import GetAppIcon from "@material-ui/icons/GetApp";
import InstitutionProfile from "../commons/institution_profile";
import ReactToPrint from "react-to-print";
import moment from "moment";
import commaNumber from "comma-number";

import "../commons/commons.css";

import _ from "lodash";

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import swal from "sweetalert";

import { exportToExcel } from "../../lib/functions"
import {
  cacheSalesMasterData,
  loadSalesMasterData,
  cacheSalesRecordResult,
  loadSalesRecordResult,
  buildSalesRecordCacheKey,
} from "../../lib/offlineSales";
import { stockReportFallbackKey } from "../../lib/offlineBootstrap";

const TransferRecord = ({
  location,
  currentRoute,
  currentRouteSet,
  authInfo,
}) => {
  const classes = useStyles();
  useEffect(() => {
    currentRouteSet(pathSpliter(location.pathname, 1));
  }, []);
  let [products, productsSet] = useState([]);
  let [categories, categoriesSet] = useState([]);
  let [brands, brandsSet] = useState([]);
  let [selectedProduct, selectedProductSet] = useState(null);
  let [selectedCategory, selectedCategorySet] = useState(null);
  let [selectedBrand, selectedBrandSet] = useState(null);
  let [productStockReports, productStockReportsSet] = useState([]);
  let format = commaNumber.bindWith(",", ".");

  let [stockData, stockDataSet] = useState([]);
  let reportRef = useRef(null);
  let [print, printSet] = useState(false);
  let [excelExport, setExcelExport] = useState(false)
  let [reportLoading, reportLoadingSet] = useState(false);
  const [reportSearchText, setReportSearchText] = useState("");
  const [reportPage, setReportPage] = useState(1);
  const [reportPagination, setReportPagination] = useState({
    page: 1,
    perPage: 50,
    total: 0,
    totalPages: 0,
  });
  const [recentProductIds, setRecentProductIds] = useState([]);
  const [autoReportRequested, setAutoReportRequested] = useState(false);

  let [byDateTime, byDateTimeSet] = useState({
    fromDate: currentDateTime,
    toDate: currentDateTime,
  });

  let supplierRef = useRef(null);
  let stockTypeRef = useRef(null);
  let productFieldRef = useRef(null);
  let categoryFieldRef = useRef(null);
  let searchBtnRef = useRef(null);
  let fromDateRef = useRef(null);
  let toDateRef = useRef(null);

  let [stockTypes, stockTypesSet] = useState([
    { stock_type: "Current Stock" },
    { stock_type: "Total Stock" },
    { stock_type: "Product wise stock" },
    { stock_type: "Category wise stock" },
    // ,{'stock_type':'Brand wise stock'}
  ]);
  let [selectedStockType, selectedStockTypeSet] = useState(null);
  const getPinnedProductIds = () => {
    const stateIds = Array.isArray(location?.state?.recentProductIds)
      ? location.state.recentProductIds
      : [];
    return stateIds.length > 0 ? stateIds : recentProductIds;
  };

  const reorderStockRows = (rows, pinnedIds = []) => {
    if (!Array.isArray(rows) || rows.length === 0 || !Array.isArray(pinnedIds) || pinnedIds.length === 0) {
      return rows || [];
    }

    const pinnedSet = new Set(pinnedIds.map((id) => String(id)));
    const pinnedRows = [];
    const otherRows = [];

    rows.forEach((row) => {
      if (pinnedSet.has(String(row?.prod_id))) {
        pinnedRows.push(row);
      } else {
        otherRows.push(row);
      }
    });

    pinnedRows.sort(
      (left, right) =>
        pinnedIds.indexOf(Number(right?.prod_id)) - pinnedIds.indexOf(Number(left?.prod_id))
    );

    return [...pinnedRows, ...otherRows];
  };

  const getRowMetaValue = (row, keys) => {
    const matchedKey = keys.find((key) => {
      const value = row?.[key];
      return value !== undefined && value !== null && String(value).trim() !== "";
    });

    return matchedKey ? row[matchedKey] : "-";
  };

  const splitDisplayMetaValue = (value) =>
    String(value ?? "")
      .split(",")
      .map((item) => item.trim())
      .filter((item) => item.length > 0);

  const expandCurrentStockRowsForDisplay = (rows) => {
    return (rows || []).flatMap((row) => {
      const floorValue = getRowMetaValue(row, ["prod_floor_name", "floor_name", "FloorName"]);
      const rackValue = getRowMetaValue(row, ["prod_rack_name", "rack_name", "RackName"]);
      const floors = splitDisplayMetaValue(floorValue === "-" ? "" : floorValue);
      const racks = splitDisplayMetaValue(rackValue === "-" ? "" : rackValue);
      const rowCount = Math.max(floors.length, racks.length, 1);

      return Array.from({ length: rowCount }, (_, index) => ({
        ...row,
        __displayFloor: floors[index] || floors[floors.length - 1] || "-",
        __displayRack: racks[index] || racks[racks.length - 1] || "-",
      }));
    });
  };

  const getResolvedCurrentStockQty = (row) => {
    const candidates = [row?.prod_qty, row?.current_quantity, row?.current_stock];
    for (const candidate of candidates) {
      const parsed = parseFloat(candidate);
      if (!Number.isNaN(parsed)) return parsed;
    }
    return 0;
  };

  const getStockReportCacheKey = (payload, stockType) =>
    buildSalesRecordCacheKey({
      type: stockType,
      payload: {
        ...payload,
        fromDate: payload?.fromDate ? String(payload.fromDate) : "",
        toDate: payload?.toDate ? String(payload.toDate) : "",
      },
    });

  const loadCachedStockReport = async (cacheKey, fallback = [], stockType = null) => {
    const cached = await loadSalesRecordResult(cacheKey, fallback);
    if (Array.isArray(cached) && cached.length > 0) return cached;
    if (stockType) {
      const defaultCached = await loadSalesRecordResult(stockReportFallbackKey(stockType), fallback);
      if (Array.isArray(defaultCached) && defaultCached.length > 0) return defaultCached;
    }
    return Array.isArray(cached) ? cached : fallback;
  };

  const isDefaultStockPayload = (payload) => {
    const normalized = payload || {};
    return (
      !normalized.productId &&
      !normalized.categoryId &&
      !normalized.brandId &&
      String(normalized.search || "").trim() === "" &&
      Number(normalized.page || 1) === 1
    );
  };

  const saveCachedStockReport = async (cacheKey, rows, stockType = null, payload = null) => {
    await cacheSalesRecordResult(cacheKey, Array.isArray(rows) ? rows : []);
    if (stockType && isDefaultStockPayload(payload)) {
      await cacheSalesRecordResult(stockReportFallbackKey(stockType), Array.isArray(rows) ? rows : []);
    }
  };

  const enrichCurrentStockRows = async (rows) => {
    const enrichedRows = await Promise.all(
      (rows || []).map(async (row) => {
        const productId = row?.prod_id;
        if (!productId) return [row];

        try {
          const res = await axios.post(
            `${API_URL}/api/get-product-location`,
            { productId },
            { headers: { "auth-token": authInfo.token } }
          );

          const detailRows = Array.isArray(res?.data?.data) ? res.data.data : [];
          if (!detailRows.length) return [row];

          return detailRows.map((detail) => {
            const qty = getResolvedCurrentStockQty(detail);
            const avgRate = parseFloat(row?.prod_purchase_rate || 0);

            return {
              ...row,
              ...detail,
              current_stock: qty,
              current_quantity: qty,
              prod_qty: qty,
              stock_value: avgRate * qty,
            };
          });
        } catch (_err) {
          return [row];
        }
      })
    );

    return enrichedRows.flat();
  };

  const mergeCurrentStockRows = (rows) => {
    const grouped = new Map();

    (rows || []).forEach((row) => {
      const floorName = getRowMetaValue(row, ["prod_floor_name", "floor_name", "FloorName"]);
      const rackName = getRowMetaValue(row, ["prod_rack_name", "rack_name", "RackName"]);
      const purchaseRate = parseFloat(row?.prod_purchase_rate || 0);
      const key = [
        row?.prod_id,
        row?.prod_code,
        floorName,
        rackName,
        Number.isFinite(purchaseRate) ? purchaseRate.toFixed(6) : "0.000000",
      ].join("||");

      if (!grouped.has(key)) {
        const qty = getResolvedCurrentStockQty(row);
        grouped.set(key, {
          ...row,
          current_stock: qty,
          current_quantity: qty,
          prod_qty: qty,
          stock_value: parseFloat(row?.stock_value || 0),
          __mergeKey: key,
        });
        return;
      }

      const existing = grouped.get(key);
      const nextQty = existing.current_stock + getResolvedCurrentStockQty(row);
      const nextStockValue = parseFloat(existing.stock_value || 0) + parseFloat(row?.stock_value || 0);

      grouped.set(key, {
        ...existing,
        current_stock: nextQty,
        current_quantity: nextQty,
        prod_qty: nextQty,
        stock_value: nextStockValue,
        __mergeKey: key,
      });
    });

    return Array.from(grouped.values());
  };

  const applyWeightedAveragePurchaseRate = (rows) => {
    const groupedTotals = new Map();

    (Array.isArray(rows) ? rows : []).forEach((row) => {
      const productId = Number(row?.prod_id || 0);
      if (!productId) return;

      const qty = Number(getResolvedCurrentStockQty(row) || 0);
      const rate = Number(row?.prod_purchase_rate || 0);
      const current = groupedTotals.get(productId) || { qty: 0, value: 0 };
      current.qty += Number.isFinite(qty) ? qty : 0;
      current.value += (Number.isFinite(qty) ? qty : 0) * (Number.isFinite(rate) ? rate : 0);
      groupedTotals.set(productId, current);
    });

    return (Array.isArray(rows) ? rows : []).map((row) => {
      const productId = Number(row?.prod_id || 0);
      const aggregate = groupedTotals.get(productId);
      const averagePurchaseRate =
        aggregate && aggregate.qty > 0
          ? aggregate.value / aggregate.qty
          : Number(row?.average_purchase_rate ?? row?.prod_purchase_rate ?? 0);

      return {
        ...row,
        average_purchase_rate: averagePurchaseRate,
      };
    });
  };

  const filterTotalStockRows = (rows, keyword) => {
    const normalizedKeyword = String(keyword || "").trim().toLowerCase();
    if (!normalizedKeyword) return rows || [];

    return (rows || []).filter((row) => {
      const searchableText = [
        row?.prod_id,
        row?.prod_code,
        row?.prod_name,
        row?.prod_cat_name,
        row?.prod_unit_name,
        row?.opening_quantity,
        row?.purchased_quantity,
        row?.purchase_returned_quantity,
        row?.sold_quantity,
        row?.sales_returned_quantity,
        row?.damaged_quantity,
        row?.transfered_from_quantity,
        row?.transfered_to_quantity,
        row?.production_quantity,
        row?.current_quantity,
        row?.stock_value,
        row?.prod_purchase_rate,
        row?.prod_re_order_lebel,
      ]
        .map((value) => String(value ?? "").toLowerCase())
        .join(" ");

      return searchableText.includes(normalizedKeyword);
    });
  };

  let getProducts = async () => {
    try {
      const res = await axios.post(
        `${API_URL}/api/get-products`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      );
      const nextValue = Array.isArray(res?.data?.message) ? res.data.message : [];
      productsSet(nextValue);
      await cacheSalesMasterData("products", nextValue);
    } catch (_error) {
      productsSet(await loadSalesMasterData("products", []));
    }
  };

  let getCategories = () => {
    axios
      .post(
        `${API_URL}/api/get-categories`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      )
      .then((res) => {
        const nextValue = Array.isArray(res?.data?.message) ? res.data.message : [];
        categoriesSet(nextValue);
        cacheSalesMasterData("categories", nextValue);
      })
      .catch(async () => {
        categoriesSet(await loadSalesMasterData("categories", []));
      });
  };

  let getBrands = () => {
    axios
      .post(
        `${API_URL}/api/get-brands`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      )
      .then((res) => {
        const nextValue = Array.isArray(res?.data?.message) ? res.data.message : [];
        brandsSet(nextValue);
        cacheSalesMasterData("brands", nextValue);
      })
      .catch(async () => {
        brandsSet(await loadSalesMasterData("brands", []));
      });
  };

  let getSearchResult = async (pageOverride = reportPage, searchOverride = reportSearchText) => {
    if (selectedStockType == null) {
      swal({ title: "Select Stock Type", icon: "warning" });
      return false;
    }

    let payload = {
      productId:
        selectedStockType.stock_type == "Product wise stock" &&
          selectedProduct != null
          ? selectedProduct.prod_id
          : null,
      categoryId:
        selectedStockType.stock_type == "Category wise stock" &&
          selectedCategory != null
          ? selectedCategory.prod_cat_id
          : null,
      brandId:
        selectedStockType.stock_type == "Brand wise stock" &&
          selectedBrand != null
          ? selectedBrand.prod_brand_id
          : null,
      search:
        selectedStockType.stock_type == "Total Stock"
          ? String(searchOverride || "").trim()
          : "",
      page:
        selectedStockType.stock_type == "Total Stock"
          ? pageOverride
          : 1,
      fromDate: byDateTime.fromDate,
      toDate: byDateTime.toDate,
    };

    let url = ``;
    if (selectedStockType.stock_type == "Current Stock") {
      url = `/get-product-current-stock-detail`;
    } else {
      url = `/get-product-total-stock`;
    }
    reportLoadingSet(true);
    try {
      const res = await axios.post(
        `${API_URL}/api${url}`,
        { ...payload },
        { headers: { "auth-token": authInfo.token } }
      );
        const cacheKey = getStockReportCacheKey(payload, selectedStockType.stock_type);

        if (selectedStockType.stock_type == "Current Stock") {
          const normalizedRows = Array.isArray(res.data) ? res.data : [];
          const mergedRows = mergeCurrentStockRows(normalizedRows);
          const weightedRows = applyWeightedAveragePurchaseRate(mergedRows);
          stockDataSet(reorderStockRows(weightedRows, getPinnedProductIds()));
          await saveCachedStockReport(cacheKey, weightedRows, selectedStockType.stock_type, payload);
          setReportPagination({
            page: Number(pageOverride) || 1,
            perPage: 50,
            total: weightedRows.length,
            totalPages: Math.ceil(weightedRows.length / 50) || 0,
        });
      } else {
        const rows = Array.isArray(res?.data?.data) ? res.data.data : [];
        const pagination = res?.data?.pagination || {
          page: pageOverride,
          perPage: 50,
          total: rows.length,
          totalPages: rows.length > 0 ? 1 : 0,
        };
        const orderedRows = reorderStockRows(rows, getPinnedProductIds());
        const filteredRows = filterTotalStockRows(orderedRows, searchOverride);
        const weightedRows = applyWeightedAveragePurchaseRate(filteredRows);
        stockDataSet(weightedRows);
        await saveCachedStockReport(cacheKey, weightedRows, selectedStockType.stock_type, payload);
        setReportPagination({
          page: Number(pagination.page) || pageOverride,
          perPage: Number(pagination.perPage) || 50,
          total: String(searchOverride || "").trim()
            ? weightedRows.length
            : Number(pagination.total) || 0,
          totalPages: String(searchOverride || "").trim()
            ? (weightedRows.length > 0 ? 1 : 0)
            : Number(pagination.totalPages) || 0,
        });
      }

      printSet(true);
    } catch (error) {
      const cacheKey = getStockReportCacheKey(payload, selectedStockType.stock_type);
      const cachedRows = await loadCachedStockReport(cacheKey, [], selectedStockType.stock_type);
      if (cachedRows.length > 0) {
        const restoredRows = selectedStockType.stock_type == "Current Stock"
          ? reorderStockRows(applyWeightedAveragePurchaseRate(cachedRows), getPinnedProductIds())
          : reorderStockRows(applyWeightedAveragePurchaseRate(filterTotalStockRows(cachedRows, searchOverride)), getPinnedProductIds());
        stockDataSet(restoredRows);
        setReportPagination({
          page: selectedStockType.stock_type == "Current Stock" ? 1 : Number(pageOverride) || 1,
          perPage: 50,
          total: restoredRows.length,
          totalPages:
            selectedStockType.stock_type == "Current Stock"
              ? Math.ceil(restoredRows.length / 50) || 0
              : restoredRows.length > 0 ? 1 : 0,
        });
        printSet(true);
      } else {
        stockDataSet([]);
        printSet(false);
        swal({
          title: "No offline stock data available",
          text: "Open this report once online to cache the data for offline use.",
          icon: "info",
        });
      }
    } finally {
      reportLoadingSet(false);
    }
  };

  useEffect(() => {
    const redirectState = location?.state || {};
    const requestedStockType = redirectState?.autoStockType;
    const incomingRecentProductIds = Array.isArray(redirectState?.recentProductIds)
      ? redirectState.recentProductIds
      : [];

    if (incomingRecentProductIds.length > 0) {
      setRecentProductIds(incomingRecentProductIds);
    }

    if (!requestedStockType || autoReportRequested) return;

    const matchedStockType = stockTypes.find(
      (item) => item.stock_type === requestedStockType
    );

    if (matchedStockType) {
      selectedStockTypeSet(matchedStockType);
      setAutoReportRequested(true);
    }
  }, [location?.state, autoReportRequested, stockTypes]);

  useEffect(() => {
    if (!autoReportRequested || !selectedStockType) return;
    if (selectedStockType.stock_type !== "Total Stock") return;

    getSearchResult(1, reportSearchText);
  }, [autoReportRequested, selectedStockType]);

  useEffect(() => {
    const handleSalesStockUpdated = () => {
      if (!selectedStockType) return;
      getSearchResult(reportPage, reportSearchText);
    };

    window.addEventListener("sales-stock-updated", handleSalesStockUpdated);
    return () => window.removeEventListener("sales-stock-updated", handleSalesStockUpdated);
  }, [selectedStockType, reportPage, reportSearchText]);

  const handleExcelExport = () => {
    let exportData = [];
    let columnWidths = [];

    if (selectedStockType.stock_type === "Current Stock") {
      const totalCurrentStock = stockData.reduce(
        (sum, row) => sum + getResolvedCurrentStockQty(row),
        0
      );
      const totalStockValue = stockData.reduce(
        (sum, row) => sum + parseFloat(row.stock_value || 0),
        0
      );

      exportData = stockData.map((row, sl) => ({
        "SL": sl + 1,
        "Product Code": row.prod_code,
        "Product Name": row.prod_name,
        "Category": row.prod_cat_name,
        "Brand": getRowMetaValue(row, ["prod_brand_name", "brand_name", "BrandName"]),
        "Country": getRowMetaValue(row, ["prod_color_name", "color_name", "country_name", "CountryName"]),
        "Floor": getRowMetaValue(row, ["prod_floor_name", "floor_name", "FloorName"]),
        "Rack": getRowMetaValue(row, ["prod_rack_name", "rack_name", "RackName"]),
        "Purchase Rate": format(parseFloat(row.prod_purchase_rate || 0).toFixed(2)),
        "Purchase Avarge Rate": format(parseFloat(row.average_purchase_rate || 0).toFixed(2)),
        "Current Quantity": `${format(getResolvedCurrentStockQty(row).toFixed(2))} ${row.prod_unit_name}`,
        "Stock Value": format(parseFloat(row.stock_value).toFixed(2))
      }));

      exportData.push({
        "SL": "",
        "Product Code": "",
        "Product Name": "Total",
        "Category": "",
        "Brand": "",
        "Country": "",
        "Floor": "",
        "Rack": "",
        "Purchase Rate": "",
        "Purchase Avarge Rate": "",
        "Current Quantity": format(totalCurrentStock.toFixed(2)),
        "Stock Value": format(totalStockValue.toFixed(2))
      });

      columnWidths = [
        { wch: 5 },   // SL
        { wch: 15 },  // Product Code
        { wch: 30 },  // Product Name
        { wch: 20 },  // Category
        { wch: 18 },  // Brand
        { wch: 18 },  // Country
        { wch: 15 },  // Floor
        { wch: 15 },  // Rack
        { wch: 18 },  // Purchase Rate
        { wch: 18 },  // Purchase Avg Rate
        { wch: 25 },  // Current Quantity
        { wch: 20 },  // Stock Value
      ]

    } else {
      const fieldsToSum = [
        "purchased_quantity",
        "purchase_returned_quantity",
        "damaged_quantity",
        "sold_quantity",
        "sales_returned_quantity",
        "transfered_from_quantity",
        "transfered_to_quantity",
        "current_quantity",
        "stock_value",
      ];

      const totals = fieldsToSum.reduce((acc, key) => {
        acc[key] = stockData.reduce((sum, row) => sum + parseFloat(row[key] || 0), 0);
        return acc;
      }, {});

      exportData = stockData.map((row, sl) => ({
        "SL": sl + 1,
        "Product Code": row.prod_code,
        "Product Name": row.prod_name,
        "Category": row.prod_cat_name,
        "Purchased": format(row.purchased_quantity),
        "P. Returned": format(row.purchase_returned_quantity),
        "Damaged": format(row.damaged_quantity),
        "Sold": format(row.sold_quantity),
        "S. Returnd": format(row.sales_returned_quantity),
        "Transfered": format(row.transfered_from_quantity),
        "Received": format(row.transfered_to_quantity),
        "Avarge Rate": format(parseFloat(row.average_purchase_rate ?? row.prod_purchase_rate ?? 0).toFixed(2)),
        "Current Quantity": `${format(parseFloat(row.current_quantity).toFixed(2))} ${row.prod_unit_name}`,
        "Stock Value": format(parseFloat(row.stock_value).toFixed(2)),
      }));

      exportData.push({
        "SL": "",
        "Product Code": "",
        "Product Name": "Total",
        "Category": "",
        "Purchased": format(totals.purchased_quantity.toFixed(2)),
        "P. Returned": format(totals.purchase_returned_quantity.toFixed(2)),
        "Damaged": format(totals.damaged_quantity.toFixed(2)),
        "Sold": format(totals.sold_quantity.toFixed(2)),
        "S. Returnd": format(totals.sales_returned_quantity.toFixed(2)),
        "Transfered": format(totals.transfered_from_quantity.toFixed(2)),
        "Received": format(totals.transfered_to_quantity.toFixed(2)),
        "Avarge Rate": "",
        "Current Quantity": format(totals.current_quantity.toFixed(2)),
        "Stock Value": format(totals.stock_value.toFixed(2)),
      });

      columnWidths = [
        { wch: 5 },   // SL
        { wch: 15 },  // Product Code
        { wch: 30 },  // Product Name
        { wch: 20 },  // Category
        { wch: 12 },  // Purchased
        { wch: 12 },  // P. Returned
        { wch: 12 },  // Damaged
        { wch: 12 },  // Sold
        { wch: 12 },  // S. Returned
        { wch: 12 },  // Transfered
        { wch: 12 },  // Received
        { wch: 16 },  // Avg Rate
        { wch: 22 },  // Current Quantity
        { wch: 20 },  // Stock Value
      ];

    }

    exportToExcel(exportData, `${selectedStockType.stock_type} Data.xlsx`, columnWidths)
  }

  let ReportDom = React.forwardRef((props, ref) => {
    const currentPage = Math.max(Number(reportPagination.page || 1), 1);
    const currentPerPage = Math.max(Number(reportPagination.perPage || 50), 50);
    const currentStockPageRows =
      selectedStockType?.stock_type === "Current Stock"
        ? stockData.slice((currentPage - 1) * currentPerPage, currentPage * currentPerPage)
        : stockData;
    const currentStockDisplayRows = expandCurrentStockRowsForDisplay(currentStockPageRows);
    return (
      <div ref={ref}>
        <InstitutionProfile />

        <div style={{ clear: "both" }}></div>
        <Paper
          style={{ width: "100%", paddingLeft: "10px", paddingRight: "10px" }}
          className="print-source"
        >
          <p style={{ width: "100%", textAlign: "center", fontWeight: "bold" }}>
            Product Stock Report
          </p>
        </Paper>

        {stockData.length > 0 &&
          selectedStockType != null &&
          selectedStockType.stock_type == "Current Stock" ? (
          <Paper
            className={classes.paper}
            style={{ marginTop: "8px", marginBottom: "5px" }}
          >
            <TableContainer>
              <Table
                className={`${classes.table} report-dom`}
                size="small"
                aria-label="a dense table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell align="left" style={{ width: "1%" }}>
                      SL
                    </TableCell>
                    <TableCell align="left">Product Code</TableCell>
                    <TableCell align="left">Product Name </TableCell>
                    <TableCell align="left">Category</TableCell>
                    <TableCell align="left">Brand</TableCell>
                    <TableCell align="left">Country</TableCell>
                    <TableCell align="left">Floor</TableCell>
                    <TableCell align="left">Rack</TableCell>
                    <TableCell align="left">Purchase Rate</TableCell>
                    <TableCell align="left">Purchase Avarge Rate</TableCell>

                    <TableCell align="left">Current Quantity</TableCell>
                    <TableCell align="right">Stock Value</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentStockDisplayRows.map((row, sl) => (
                    <TableRow key={`${row.prod_id}-${sl}`} className={getResolvedCurrentStockQty(row) <= row.prod_re_order_lebel ? classes.lowStock : ""}>
                      <TableCell>{((currentPage - 1) * currentPerPage) + sl + 1}.</TableCell>
                      <TableCell align="left">{row.prod_code}</TableCell>
                      <TableCell align="left">{row.prod_name}</TableCell>
                      <TableCell align="left">{row.prod_cat_name}</TableCell>
                      <TableCell align="left">
                        {getRowMetaValue(row, ["prod_brand_name", "brand_name", "BrandName"])}
                      </TableCell>
                      <TableCell align="left">
                        {getRowMetaValue(row, ["prod_color_name", "color_name", "country_name", "CountryName"])}
                      </TableCell>
                      <TableCell align="left">
                        {row.__displayFloor || getRowMetaValue(row, ["prod_floor_name", "floor_name", "FloorName"])}
                      </TableCell>
                      <TableCell align="left">
                        {row.__displayRack || getRowMetaValue(row, ["prod_rack_name", "rack_name", "RackName"])}
                      </TableCell>
                      <TableCell align="left">
                        {format(parseFloat(row.prod_purchase_rate || 0).toFixed(2))}
                      </TableCell>
                      <TableCell align="left">
                        {format(parseFloat(row.average_purchase_rate || 0).toFixed(2))}
                      </TableCell>
                      <TableCell align="left">
                        {format(getResolvedCurrentStockQty(row).toFixed(2))}{" "}
                        {row.prod_unit_name}
                      </TableCell>
                      <TableCell align="right">
                        {format(parseFloat(row.stock_value).toFixed(2))}
                      </TableCell>
                    </TableRow>
                  ))}
                  <br></br>
                  <TableRow>
                    <TableCell colSpan={9}></TableCell>
                    <TableCell>Total : </TableCell>
                    <TableCell>
                      {format(
                        Number(
                          stockData.reduce((sum, row) => sum + getResolvedCurrentStockQty(row), 0) || 0
                        ).toFixed(2)
                      )}
                    </TableCell>
                    <TableCell align="right">
                      {format(
                        Number(_.sumBy(stockData, "stock_value") || 0).toFixed(
                          2
                        )
                      )}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px", marginTop: "12px", flexWrap: "wrap" }}>
              <div style={{ fontSize: "14px", color: "#5f6368" }}>
                {reportPagination.total > 0
                  ? `Showing page ${reportPagination.page} of ${reportPagination.totalPages || 1} (${reportPagination.total} products)`
                  : "No products found."}
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    setReportPagination((prev) => ({
                      ...prev,
                      page: Math.max(Number(prev.page || 1) - 1, 1),
                    }));
                  }}
                  disabled={reportLoading || reportPagination.page <= 1}
                >
                  Prev
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    setReportPagination((prev) => ({
                      ...prev,
                      page: Math.min(
                        Number(prev.page || 1) + 1,
                        Math.max(Number(prev.totalPages || 1), 1)
                      ),
                    }));
                  }}
                  disabled={
                    reportLoading ||
                    reportPagination.totalPages === 0 ||
                    reportPagination.page >= reportPagination.totalPages
                  }
                >
                  Next
                </Button>
              </div>
            </div>
          </Paper>
        ) : (
          ""
        )}

        {/* Total Stock  */}

        {stockData.length > 0 &&
          selectedStockType != null &&
          selectedStockType.stock_type != "Current Stock" ? (
          <Paper
            className={classes.paper}
            style={{ marginTop: "8px", marginBottom: "5px" }}
          >
            <TableContainer>
              <Table
                className={`${classes.table} report-dom`}
                size="small"
                aria-label="a dense table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell align="left" style={{ width: "1%" }}>
                      SL
                    </TableCell>
                    <TableCell align="left"> Code</TableCell>
                    <TableCell align="left"> Name </TableCell>
                    <TableCell align="left">Category</TableCell>
                    <TableCell align="left">Opening Stock </TableCell>
                    <TableCell align="left">Purchased </TableCell>
                    <TableCell align="left">P. Returnd </TableCell>
                    {/* <TableCell align="left">Production</TableCell> */}
                    <TableCell align="left">Damaged </TableCell>
                    <TableCell align="left">Sold </TableCell>
                    <TableCell align="left">S. Returnd </TableCell>
                    <TableCell align="left">Transfered </TableCell>
                    <TableCell align="left">Received</TableCell>
                    <TableCell align="left"> AVG. Rate</TableCell>
                    <TableCell align="right">Current Qty </TableCell>
                    <TableCell align="right">Stock Value</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stockData.map((row, sl) => (
                    <TableRow key="sl" className={row.current_quantity < row.prod_re_order_lebel ? classes.lowStock : ""}>
                      <TableCell>{((reportPagination.page - 1) * reportPagination.perPage) + sl + 1}.</TableCell>
                      <TableCell align="left">{row.prod_code}</TableCell>
                      <TableCell align="left">{row.prod_name}</TableCell>
                      <TableCell align="left">{row.prod_cat_name}</TableCell>
                      <TableCell align="left">
                        {format(row.opening_quantity)}
                      </TableCell>
                      <TableCell align="left">
                        {format(row.purchased_quantity)}
                      </TableCell>
                      <TableCell align="left">
                        {format(row.purchase_returned_quantity)}
                      </TableCell>
                      {/* <TableCell align="left">
                        {format(row.production_quantity)}
                      </TableCell> */}
                      <TableCell align="left">
                        {format(row.damaged_quantity)}
                      </TableCell>
                      <TableCell align="left">
                        {format(row.sold_quantity)}
                      </TableCell>
                      <TableCell align="left">
                        {format(row.sales_returned_quantity)}
                      </TableCell>
                      <TableCell align="left">
                        {format(row.transfered_from_quantity)}
                      </TableCell>
                      <TableCell align="left">
                        {format(row.transfered_to_quantity)}
                      </TableCell>
                      <TableCell align="left">
                        {format(parseFloat(row.average_purchase_rate ?? row.prod_purchase_rate ?? 0).toFixed(2))}
                      </TableCell>
                      <TableCell align="right">
                        {format(parseFloat(row.current_quantity).toFixed(2))}{" "}
                        {row.prod_unit_name}
                      </TableCell>
                      <TableCell align="right">
                        {format(parseFloat(row.stock_value).toFixed(2))}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px", marginTop: "12px", flexWrap: "wrap" }}>
              <div style={{ fontSize: "14px", color: "#5f6368" }}>
                {reportPagination.total > 0
                  ? `Showing page ${reportPagination.page} of ${reportPagination.totalPages || 1} (${reportPagination.total} products)`
                  : "No products found."}
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    const nextPage = Math.max(reportPage - 1, 1);
                    setReportPage(nextPage);
                    getSearchResult(nextPage, reportSearchText);
                  }}
                  disabled={reportLoading || reportPagination.page <= 1}
                >
                  Prev
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    const nextPage = Math.min(
                      reportPage + 1,
                      Math.max(reportPagination.totalPages || 1, 1)
                    );
                    setReportPage(nextPage);
                    getSearchResult(nextPage, reportSearchText);
                  }}
                  disabled={
                    reportLoading ||
                    reportPagination.totalPages === 0 ||
                    reportPagination.page >= reportPagination.totalPages
                  }
                >
                  Next
                </Button>
              </div>
            </div>
          </Paper>
        ) : (
          ""
        )}
      </div>
    );
  });

  return (
    <div className={classes.root}>
      <Paper
        className={classes.paper}
        style={{ marginTop: "-25px", marginBottom: "5px" }}
      >
        <h4
          style={{
            textAlign: "left",
            margin: 0,
            padding: 0,
            marginTop: "-10px",
            marginBottom: "2px",
          }}
        >
          Product Stock Report
        </h4>

        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <Autocomplete
              size="small"
              autoHighlight
              openOnFocus={true}
              style={{ width: "100%", height: "20px" }}
              options={stockTypes}
              value={selectedStockType}
              getOptionLabel={(option) => option.stock_type}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  setTimeout(() => searchBtnRef.current?.focus(), 0)
                }
              }}
              onChange={(event, selectedObj) => {
                selectedStockTypeSet(selectedObj);

                if (selectedObj == null) return false;

                // Start

                if (selectedObj.stock_type == "Product wise stock") {
                  getProducts();
                  selectedCategorySet(null);
                  selectedBrandSet(null);
                }
                if (selectedObj.stock_type == "Category wise stock") {
                  getCategories();
                  selectedProductSet(null);
                  selectedBrandSet(null);
                }

                if (selectedObj.stock_type == "Brand wise stock") {
                  getBrands();
                  selectedProductSet(null);
                  selectedCategorySet(null);
                }

                setReportSearchText("");
                setReportPage(1);
                setReportPagination({
                  page: 1,
                  perPage: 50,
                  total: 0,
                  totalPages: 0,
                });
                stockDataSet([]);

                // End
              }}
              renderInput={(params) => (
                <TextField inputRef={stockTypeRef} {...params} label="Stock Type " variant="outlined" />
              )}
            />
          </Grid>
          {selectedStockType != null &&
            selectedStockType.stock_type == "Product wise stock" ? (
            <Grid item xs={12} sm={3}>
              <Autocomplete
                size="small"
                autoHighlight
                openOnFocus={true}
                style={{ width: "100%", height: "20px" }}
                options={products}
                value={selectedProduct}
                getOptionLabel={(option) => `${option?.prod_code || ""} ${option?.prod_name || ""}`.trim()}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    setTimeout(() => searchBtnRef.current?.click(), 0)
                  }
                }}
                onChange={(event, selectedObj) => {
                  selectedProductSet(selectedObj);
                  stockDataSet([]);
                  setTimeout(() => searchBtnRef.current?.focus(), 0)
                }}
                renderInput={(params) => (
                  <TextField
                    inputRef={productFieldRef}
                    {...params}
                    label="Product Name"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
          ) : (
            ""
          )}

          {selectedStockType != null &&
            selectedStockType.stock_type == "Category wise stock" ? (
            <Grid item xs={12} sm={3}>
              <Autocomplete
                size="small"
                autoHighlight
                openOnFocus={true}
                style={{ width: "100%", height: "20px" }}
                options={categories}
                value={selectedCategory}
                getOptionLabel={(option) => option?.prod_cat_name ?? ""}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    setTimeout(() => searchBtnRef.current?.click(), 0)
                  }
                }}
                onChange={(event, selectedObj) => {
                  selectedCategorySet(selectedObj);
                  stockDataSet([]);
                  setTimeout(() => searchBtnRef.current?.focus(), 0)
                }}
                renderInput={(params) => (
                  <TextField
                    inputRef={categoryFieldRef}
                    {...params}
                    label="Category Name"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
          ) : (
            ""
          )}

          {selectedStockType != null &&
            selectedStockType.stock_type == "Brand wise stock" ? (
            <Grid item xs={12} sm={3} style={{ display: "none" }}>
              <Autocomplete
                size="small"
                autoHighlight
                openOnFocus={true}
                style={{ width: "100%", height: "20px" }}
                options={brands}
                value={selectedBrand}
                getOptionLabel={(option) => option?.prod_brand_name ?? ""}
                onChange={(event, selectedObj) => {
                  selectedBrandSet(selectedObj);
                  stockDataSet([]);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Brand Name"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
          ) : (
            ""
          )}

          <Grid item xs={12} sm={1}>
            <Button
              style={{ marginTop: "5px", marginLeft: "auto", fontSize: "14px" }}
              variant="contained"
              color="primary"
              className={classes.button}
              buttonRef={searchBtnRef}
              startIcon={<SearchIcon />}
              onClick={() => {
                setReportPage(1);
                getSearchResult(1, reportSearchText);
              }}
              disabled={reportLoading ? true : false}
            >
              Search
            </Button>
          </Grid>
        </Grid>
        {selectedStockType != null &&
          selectedStockType.stock_type == "Total Stock" ? (
          <Grid container spacing={3} style={{ marginTop: "6px" }}>
            <Grid item xs={12} sm={4}>
              <TextField
                size="small"
                variant="outlined"
                label="Search Product"
                placeholder="Code, name, category, qty, rate..."
                value={reportSearchText}
                onChange={(e) => {
                  const nextValue = e.target.value;
                  setReportSearchText(nextValue);

                  if (String(nextValue).trim() === "") {
                    setReportPage(1);
                    getSearchResult(1, "");
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    setReportPage(1);
                    getSearchResult(1, e.target.value);
                  }
                }}
                style={{ width: "100%" }}
              />
            </Grid>
          </Grid>
      ) : (
          ""
        )}
      </Paper>

      {reportLoading ? (
        <div className={classes.reportLoadingOverlay}>
          <div className={classes.reportLoadingCard}>
            <CircularProgress size={34} thickness={4.5} style={{ color: "#0F7E77" }} />
            <div className={classes.reportLoadingText}>Loading report...</div>
            <div className={classes.reportLoadingSubText}>Searching and refreshing data</div>
          </div>
        </div>
      ) : null}

      {print ? (
        <Grid container>
          <Grid item xs={12} sm={12}>
            <Paper style={{ borderRadius: "0px", marginTop: "-7px" }}>
              <ReactToPrint
                trigger={() => (
                  <PrintIcon
                    style={{
                      cursor: "pointer",
                      marginLeft: "30px",
                      marginTop: "3px",
                      marginBottom: "-8px",
                    }}
                  />
                )}
                content={() => reportRef.current}
              />
              <Tooltip title="Excel Download">
                <IconButton>
                  <GetAppIcon
                    onClick={handleExcelExport}
                  />
                </IconButton>
              </Tooltip>
            </Paper>
          </Grid>
        </Grid>
      ) : (
        ""
      )}

      <ReportDom ref={reportRef} />
    </div>
  );
};
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  inputField: {
    width: "100%",
    marginTop: "5px",
  },
  plusLinkDiv: {
    position: "relative",
  },
  plusLink: {
    margin: 0,
    padding: 0,
    marginTop: "-21px",
    fontSize: "29px",
    height: "21px",
    textAlign: "right",
    position: "absolute",
    right: 0,
    color: "#3e8d54",
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  reportLoadingOverlay: {
    position: "fixed",
    inset: 0,
    zIndex: 2000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(255, 255, 255, 0.45)",
    backdropFilter: "blur(2px)",
    WebkitBackdropFilter: "blur(2px)",
  },
  reportLoadingCard: {
    minWidth: 220,
    padding: "20px 24px",
    borderRadius: "18px",
    background: "#ffffff",
    boxShadow: "0 18px 50px rgba(15, 126, 119, 0.18)",
    border: "1px solid rgba(15, 126, 119, 0.12)",
    textAlign: "center",
  },
  reportLoadingText: {
    marginTop: "10px",
    fontSize: "15px",
    fontWeight: 700,
    color: "#0F7E77",
  },
  reportLoadingSubText: {
    marginTop: "4px",
    fontSize: "12px",
    color: "#65727a",
  },
  lowStock: {
    backgroundColor: "#f27f5c !important",
  },
}));

const mapStateToPops = (state) => {
  return {
    currentRoute: state.currentRouteReducer,
    authInfo: state.authInfoReducer,
  };
};
export default connect(mapStateToPops, { currentRouteSet })(TransferRecord);
